import Head from 'next/head'
import Image from 'next/image'
import redis from "@/lib/redis"

{/* importing components */}
import Header from '../components/Header'
import Events from '../components/Events'
import BlogPosts from '../components/BlogPosts'
import ClanCTA from '../components/ClanCTA'
{/* finished importing components */}

export default function Home({ headerItems }) {
  return (
    <>
      <Head>
        <title>Combat Warriors</title>
        <meta name="description" content="Welcome to the official Combat Warriors website! Read our blog, check out our wiki, and connect with other players!" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
        <meta name="theme-color" content="#000000" />
        <meta property="og:title" content="Combat Warriors" />
        <meta property="og:description" content="Welcome to the official Combat Warriors website! Read our blog, check out our wiki, and connect with other players!" />
        <meta property="og:image" content="https://assets.combatwarriors.gg/new_og_image.png" />
        <meta property="og:url" content="https://combatwarriors.gg" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Combat Warriors" />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      
      <main>
        <Header items={headerItems} />
        <BlogPosts />
        <Events />
        <ClanCTA />
      </main>
    </>
  )
}

export async function getServerSideProps() {
  let headerItems = await redis.get("headerItems") || [];
  if (!headerItems || headerItems.length === 0) {
    const response = await fetch(`${process.env.CMS_URL}/api/header`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${process.env.CMS_API_KEY}`
      }
    });
    const data = await response.json();
    
    if (data && data.docs.length > 0) {
      headerItems = JSON.stringify(data.docs);
      await redis.set("headerItems", headerItems, "EX", 60 * 5); // Cache for 5 Minutes
    } else {
      headerItems = JSON.stringify([]);
    }
  }

  return {
    props: {
      headerItems: JSON.parse(headerItems).map(item => ({
        ...item,
        image: {
          url: `https://assets.combatwarriors.gg/payload/${(item.image?.url || '').replace(/^\/?api\//, '').replace(/\/?file\//, '/')}`,
          alt: item.image?.alt || 'Header Image',
        }
      })),
    },
  };
}